export function radToDeg(rad: number): number {
  return (rad / Math.PI) * 180;
}
